import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Compré un sábado a la noche. El domingo antes del partido repasé el sistema de distribución táctica. Fue el mejor partido que jugué en todo el año. Mi entrenador me pidió que le contara qué estaba haciendo diferente.',
  name: 'Matías L.',
  role: 'Armador en Club Deportivo',
  location: 'Buenos Aires'
}, {
  quote: 'El Tomo 3, el de distribución y toma de decisiones, me cambió completamente. El primer mes, situaciones que antes me paralizaban empecé a resolverlas con naturalidad. El árbol de decisiones vale oro.',
  name: 'Sebastián R.',
  role: 'Armador en Liga Regional',
  location: 'Rosario'
}, {
  quote: 'El sistema de progresión es único en el mercado. 80 drills listos para usar con diagramas de cancha, objetivos y variantes por nivel. Antes no sabía qué trabajar en cada entrenamiento. Ahora abro el PDF y en 5 minutos tengo todo claro.',
  name: 'Nicolás F.',
  role: 'Armador Competitivo',
  location: 'Córdoba'
}, {
  quote: 'Las planillas del Tomo 5 eliminaron mi inseguridad con la parte física. Ahora sé exactamente qué trabajar según mi posición y puedo mostrarle a mi entrenador un plan real de desarrollo. Mis entrenamientos tienen otro nivel.',
  name: 'Lucas P.',
  role: 'Armador Particular y en Club',
  location: 'Tucumán'
}, {
  quote: 'Mi rendimiento bajo presión mejoró muchísimo. Sin cambiar cuánto entreno. Solo aplicando el sistema mental y los protocolos de decisión. Ahora en el momento clave del partido siento claridad donde antes sentía pánico.',
  name: 'Federico G.',
  role: 'Armador Online y Presencial',
  location: 'Mendoza'
}, {
  quote: 'El Pack Élite me cambió la cabeza. Nunca había dimensionado el potencial de trabajar el liderazgo y la marca personal como armador. Ahora tengo una autoridad dentro del equipo que antes no tenía y mi entrenador me ve diferente.',
  name: 'Agustín R.',
  role: 'Armador en Centro Deportivo',
  location: 'Salta'
}];
export const TestimonialsGrid = () => {
  return <section className="py-12 md:py-24 bg-navy-900 relative overflow-hidden" data-id="element-404">
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-405" />
      <div className="container mx-auto px-4" data-id="element-406">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-407">
          <h2 className="text-3xl md:text-6xl font-bebas text-white mb-3 md:mb-4" data-id="element-408">
            Lo que dicen los armadores que ya lo usan:
          </h2>
          <p className="text-base md:text-xl text-gold-500" data-id="element-409">
            +200 armadores de voleibol de todo el país ya tienen su Armador de
            Élite™
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-410">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-navy-950 border border-navy-800 p-5 md:p-8 rounded-2xl flex flex-col" data-id="element-411">
              <div className="flex gap-1 mb-4 md:mb-6" data-id="element-412">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-413" />)}
              </div>
              <p className="text-gray-300 text-sm md:text-base italic mb-4 md:mb-8 flex-grow leading-relaxed" data-id="element-414">
                "{t.quote}"
              </p>
              <div className="border-t border-navy-800 pt-4" data-id="element-415">
                <div className="font-bold text-white" data-id="element-416">{t.name}</div>
                <div className="text-sm text-gray-400 mt-1 flex flex-col gap-1" data-id="element-417">
                  <span data-id="element-418">{t.role}</span>
                  <span className="flex items-center gap-1 text-gold-500/80" data-id="element-419">
                    <MapPin className="w-3 h-3" data-id="element-420" /> {t.location}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};